import { Link } from "react-router-dom";
import { CONTACT, LOGO_SRC } from "@/constants/site";

export default function Footer() {
  return (
    <footer className="relative z-10 bg-brand-dark text-brand-cream mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={LOGO_SRC} alt="AM Group of Education" className="h-14 w-auto object-contain" />
            <div>
              <div className="display-serif text-xl font-bold">AM Group of Education</div>
              <div className="text-xs tracking-widest uppercase text-brand-light">Learn Today, Lead Tomorrow</div>
            </div>
          </div>
          <p className="text-sm text-brand-cream/80 leading-relaxed">
            One institute for School Education, Competitive Exams, Languages, and IT skills. Trusted by thousands of students for results-driven coaching.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold tracking-widest uppercase text-brand-gold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-brand-gold transition-colors">Home</Link></li>
            <li><Link to="/school-courses" className="hover:text-brand-gold transition-colors">School Courses</Link></li>
            <li><Link to="/competitive-exams" className="hover:text-brand-gold transition-colors">Competitive Exams</Link></li>
            <li><Link to="/government-courses" className="hover:text-brand-gold transition-colors">Government Courses</Link></li>
            <li><Link to="/about" className="hover:text-brand-gold transition-colors">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-brand-gold transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold tracking-widest uppercase text-brand-gold mb-4">Programs</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/school-courses" className="hover:text-brand-gold transition-colors">Classes 1 – 12</Link></li>
            <li><Link to="/competitive-exams" className="hover:text-brand-gold transition-colors">NEET / JEE / Foundation</Link></li>
            <li><Link to="/government-courses" className="hover:text-brand-gold transition-colors">UPSC / MPSC / SSC</Link></li>
            <li><Link to="/languages" className="hover:text-brand-gold transition-colors">Languages</Link></li>
            <li><Link to="/it-courses" className="hover:text-brand-gold transition-colors">IT Courses</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold tracking-widest uppercase text-brand-gold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-brand-cream/85">
            <li className="flex items-start gap-3"><i className="fa-solid fa-phone mt-1 text-brand-gold" /> <a href={`tel:${CONTACT.phone}`} className="hover:text-brand-gold">{CONTACT.phone}</a></li>
            <li className="flex items-start gap-3"><i className="fa-solid fa-envelope mt-1 text-brand-gold" /> <a href={`mailto:${CONTACT.email}`} className="hover:text-brand-gold break-all">{CONTACT.email}</a></li>
          </ul>
          <div className="flex items-center gap-3 mt-5">
            <a
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noreferrer"
              data-testid="social-whatsapp"
              aria-label="WhatsApp"
              className="w-11 h-11 rounded-full bg-white/10 hover:bg-brand-gold hover:text-brand-dark grid place-items-center transition-all hover:-translate-y-0.5 hover:shadow-lg"
            >
              <i className="fa-brands fa-whatsapp text-lg" />
            </a>
            <a
              href={CONTACT.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid="social-instagram"
              aria-label="Instagram"
              className="w-11 h-11 rounded-full bg-white/10 hover:bg-brand-gold hover:text-brand-dark grid place-items-center transition-all hover:-translate-y-0.5 hover:shadow-lg"
            >
              <i className="fa-brands fa-instagram text-lg" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-xs flex flex-col md:flex-row items-center justify-between gap-2 text-brand-cream/70">
          <div>© 2026 AM Group of Education. All Rights Reserved.</div>
          <div>Crafted with <i className="fa-solid fa-heart text-brand-gold" /> for ambitious students.</div>
        </div>
      </div>
    </footer>
  );
}
